import { render, staticRenderFns } from "./PopupAddNewVenue.vue?vue&type=template&id=a6548476&scoped=true&"
import script from "./PopupAddNewVenue.vue?vue&type=script&lang=js&"
export * from "./PopupAddNewVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6548476",
  null
  
)

export default component.exports